export default "__VITE_ASSET__xR0rwP1V__"